import styled from 'styled-components';

const SurveyResultsWrapper = styled.div`
  .survey-dropdown {
    width: 340px;
  }

  .rc-dropdown {
    min-width: 340px !important;
    width: 340px !important;
  }

  .image-section {
    position: absolute;
    left: 50%;
    top: 40%;
  }

  .dropdown-body {
    box-shadow: 0px 0px 12px ${({ theme }) => theme.colors.boxShadow[25]} !important;
    border-radius: 4px;
    .dropdown-item {
      padding: 6px 8px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      background-color: ${({ theme }) => theme.colors.white[100]};
      cursor: pointer;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.dark[80]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.secondary[50]};
      }
      &:nth-child(1) {
        box-shadow: none;
      }
      &:first-of-type {
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-radius: 0 0 4px 4px;
      }
    }
  }
`;

export default SurveyResultsWrapper;
